import { NormalizeApiError, setSentryErrorTags } from "@app/api/BaseAPI";
import { GetCapsuleUser, Logout } from "@app/api/CapsuleUser";
import * as Sentry from "@sentry/react";
import { useMutation, useQuery } from "@tanstack/react-query";

export const useUser = () => {
	return useQuery({
		queryKey: ["capsule-user"],
		queryFn: GetCapsuleUser,
		staleTime: Infinity,
	});
};

export const useLogout = () => {
	return useMutation({
		mutationFn: async () => {
			await Logout();
			Sentry.setUser(null);
		},
		onError: (err) => {
			const apiErr = NormalizeApiError(err);

			Sentry.withScope((scope) => {
				scope.setFingerprint(["delete", "/entries"]);
				setSentryErrorTags(scope, apiErr);
				Sentry.captureException(apiErr.captureError);
			});

			alert(
				`Something went wrong (${
					apiErr.status != null ? apiErr.status : "Unknown Status Code"
				}), please try again.`,
			);
		},
	});
};
